/* eslint-disable jsx-a11y/alt-text */
import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS } from 'src/common/constants/constants';
import { numberPrettier } from 'src/common/utils/formatters';
import { getSortedReactions, getSourceFromReaction } from '../../utils/utils';
import { Tooltip } from '@cellebrite/saas-ui-common';

interface CommentReactionsProps {
    comment: any;
    platform: string;
    onReactionsClick?: any;
}

const CommentReactions: React.FC<CommentReactionsProps> = ({ comment, platform, onReactionsClick }) => {
    const sortedReactions = useMemo(() => {
        return getSortedReactions(comment);
    }, [comment.reactionsCounts]);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, justifyContent: 'space-between' }}>
            <Tooltip
                content={
                    <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 2 }}>
                        {sortedReactions
                            .filter((reaction) => reaction.count)
                            .map((reaction, index) => {
                                const src = getSourceFromReaction(platform, reaction.type);
                                return src ? (
                                    <Box
                                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                                        key={index}
                                    >
                                        <img src={src} title={reaction.type} />
                                        <Typography sx={{ ml: 1 }} variant="s14w500" className="color-bd">
                                            {reaction.count}
                                        </Typography>
                                    </Box>
                                ) : null;
                            })}
                    </Box>
                }
                placement={'bottom'}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        visibility: comment.counts.reactions ? null : 'hidden',
                    }}
                    onClick={(event) => {
                        if (comment.reactions?.length) {
                            onReactionsClick?.(event);
                        }
                    }}
                >
                    {sortedReactions
                        .filter((reaction, index) => index < 3)
                        .map((reaction, index) => {
                            const src = getSourceFromReaction(platform, reaction.type);
                            return src ? (
                                <img
                                    src={src}
                                    style={{ zIndex: index, marginLeft: index ? '-3px' : null }}
                                    key={index}
                                />
                            ) : null;
                        })}
                    <Typography
                        variant="s14w500"
                        className="color-md"
                        sx={{
                            'ml': 0.5,
                            '&:hover': {
                                textDecoration: comment.reactions?.length ? 'underline' : null,
                                color: comment.reactions?.length ? `${COLORS.BRAND_HOVER} !important` : null,
                            },
                            'cursor': comment.reactions?.length ? 'pointer' : null,
                        }}
                    >
                        {numberPrettier(comment.counts.reactions)}
                    </Typography>
                </Box>
            </Tooltip>
        </Box>
    );
};

export default CommentReactions;
